import { useTelegram } from '@/store/telegram';
import { ucApi } from '@/config/api';

const store = useTelegram();

export const setTGStore = (id:string) => {
  // localStorage.setItem('telegram_id', id);
  store.setTelegramInfo({ id, hash: '' });
};

export const setTGToParams = (params: any, route:any) => {
  // const telegramId = localStorage.getItem('telegram_id');
  const telegramId = store.telegramInfo.id;
  const isTelegram = route.meta.telegram;
  if (isTelegram && telegramId) {
    params.app_name = 'telegram';
    params.id_token = telegramId;
  }
};

export const clearTGStore = () => {
  // localStorage.setItem('telegram_id', '');
  store.setTelegramInfo({ id: '', hash: '' });
};

export const checkTelegram = (type:string, inMiniApp = false) => {
  if (!import.meta.env.SSR) {
    if (!store.telegramInfo.id && !inMiniApp) { // miniApp bind
      const router = useRouter();
      const path =  type === 'register' ? '/register' : '/login';
      router.replace({ path });
    }
  }
};

export const checkInMiniApp = () => {
  return store.inMiniApp;
};

export const toTelegramBackUrl = () => {
  store.setInMiniApp(false);
  if (window.parent) {
    window.parent.location.href = `${store.backUrl}`;
  } else {
    window.location.href = `${store.backUrl}`;
  }
};

export const initTelegram = async() => {
  const route = useRoute();
  const source = route.query.source as string  || '';
  const backUrl = route.query.backUrl as string || localStorage.getItem('miniApp_backUrl') || '';
  // const tgWebAppData = route.hash  || localStorage.getItem('miniApp_tgHash') || '';
  const inMiniApp = source === 'miniApp' || localStorage.getItem('inMiniApp') === 'true';
  if (inMiniApp) {
    store.setInMiniApp(inMiniApp);
    store.setBackUrl(backUrl);
    // store.setTgHash(tgWebAppData);
    const res: any = await ucApi.getTelegramToken();
    if (res.success) {
      setTGStore(res.data);
    }
    webAppInit();
  }
};

// 使用 mini-app 顶部返回按钮
const webAppInit = () => {
  const telegramScript = document.createElement('script');
  telegramScript.src = '/static/telegram/web-app.js';
  telegramScript.onload = function() {
    const container = window.parent ? window.parent : window;
    const webApp = container.Telegram && container.Telegram.WebApp;
    if (webApp) {
      webApp.ready();
      webApp.BackButton?.show();
      webApp.BackButton?.onClick(function() {
        window.history?.back();
      });
    }
  };
  telegramScript.onerror = function(e) { console.log('telegram.ts/73 >>>>>> ', e); };
  document.body.appendChild(telegramScript);
};
